






























































































































































































































import CardPanel from '@/components/common/CardPanel.vue'
import { ElForm } from 'element-ui/types/form'
import {Component, Ref, Vue, Watch} from 'vue-property-decorator'
import SimpleUploader from "@/components/common/SimpleUploader.vue"
import { getDataList } from '@/request/apis/common'
import { createTask } from '@/request/apis/DataIntegrationRequest'
import SelectPanel from '@/components/common/SelectPanel.vue'
import moment from "moment"

@Component({
  components: {
    SelectPanel,
    CardPanel,
    SimpleUploader
  }
})
export default class DataIntegrationForm extends Vue {
  @Ref('form') readonly submitForm!: ElForm

  private loadingSelect: boolean = false
  private loadingProcessButton: boolean = false
  private optionList: any[] = []
  private type: string = 'DataIntegration'
  private form: any = {
    inputType: 'choose', // choose | file
    chooseData: [], // 选择的数据
    dataID: [], //上传的文件ID
    shortFileNames: '',
    dataNameID: '', //整合后数据名id 不可修改
    isConsider: 'False', // consider_batch, True | False
    batchName: 'Channel',
    // 根据选择的 h5ad 数据生成 qc metric 数据, 一个 h5ad 对应一个 qc metric 参数列表, 例如 { 'test.hdad': { minGenes: -1, ... }, ... }
    qcMetricsModel: {}
  }
  private currentDate = moment().format('YYYYMMDD')


  /**
   * 显示下拉框数据
   */
  private async selectHandler () {
    this.loadingSelect = true
    try {
      const data = await getDataList(null, this.type).start()
      // data list 没有 id, 补上 id, 因为文件名称包含有特殊字符, 直接使用会导致有些地方报错
      this.optionList = data.map((item: string) => (
        { id: this.normalizeFileName(item), label: item }
      ))
    } catch (e) {
      console.warn(e)
    }
    this.loadingSelect = false
  }

  /**
   * 更新 qcMetricsModel
   * @private
   */
  private updateModel (dataList: string[]) {
    // 从 qcMetricsModel 删除已经取消选中的
    for (const [name] of Object.entries(this.form.qcMetricsModel)) {
      if (!dataList.includes(name)) {
        this.$delete(this.form.qcMetricsModel, name)
      }
    }
    // 把新选中的更新到 qcMetricsModel
    dataList.forEach((name: string) => {
      if (!this.form.qcMetricsModel[name]) {
        this.$set(this.form.qcMetricsModel, name, {
          min_genes: -1,
          max_genes: -1,
          min_umis: -1,
          max_umis: -1,
          percent_mito: -1
        })
      }
    })
    // 更新 combine data name, 默认规则为: 选中的文件名称前三个字母 + 当前日期 + 随机数使用下划线拼接
    const randomNumber = Math.round(Math.random() * 100000)
    this.form.shortFileNames = dataList.map((name: string) => this.restoreFileName(name).substr(0, 3)).join('_')
    this.form.dataNameID = [this.currentDate, randomNumber].join('_')
  }

  /**
   * 下拉选中菜单更新
   * @private
   */
  private selectChangeHandler () {
    this.updateModel(this.form.chooseData)
  }

  /**
   * 文件上传成功
   * @param event
   * @private
   */
  private uploadSuccessHandler (event: CustomEvent) {
    const fileId = this.normalizeFileName(event.detail.fileId)
    if (!this.form.dataID.includes(fileId)) {
      this.form.dataID.push(fileId)
    }
    this.updateModel(this.form.dataID)
  }

  /**
   * 过滤掉文件名称的特殊字符
   * @param name
   * @private
   */
  private normalizeFileName (name: string) {
    return name.replace(/\./g, '$_$')
  }

  /**
   * 恢复原来的文件名称
   * @param name
   * @private
   */
  private restoreFileName (name: string) {
    return name.replace(/\$_\$/g, '.')
  }

  /**
   * 表单提交
   */
  private submitHandler () {
    this.submitForm.validate(async (valid) => {
      if (valid) {
        this.loadingProcessButton = true
        try {
          // 因为返回的文件列表只有名称没有 id, 并且部分文件名称带有点号, 会导致表单验证那里报错, 所以前面把文件名的点号替换为别的字符, 这里重新把文件名恢复原来的名称
          // 根本的解决办法还是返回的文件列表要带有 id 和名称
          let qcMetricsModel: any = {}
          for (let [name, props] of Object.entries(this.form.qcMetricsModel)) {
            name = this.restoreFileName(name)
            qcMetricsModel[name] = props
          }
          let params: any = {
            consider_batch: this.form.isConsider,
            // batch_name: this.form.batchName,
            combine_name: this.form.shortFileNames + '_' + this.form.dataNameID,
            qc: JSON.stringify(qcMetricsModel)
          }
          if (this.form.inputType === 'file') {
            params.choose_data = this.restoreFileName(this.form.dataID.join(','))
          } else {
            params.choose_data = this.restoreFileName(this.form.chooseData.join(','))
          }
          const taskDetail = await createTask(null, params).start()
          this.$emit('formSubmit', taskDetail)
        } catch (e) {
          console.warn(e)
        }
        this.loadingProcessButton = false
      } else {
        return false
      }
    })
  }

  private get rules () {
    const checkInputData = (rule: any, value: string, callback: Function) => {
      if (this.form.inputType === 'choose' && !value) {
        return callback(new Error(<string>this.$root.$t('form.choose')))
      }
      callback()
    }
    const checkFile = (rule: any, value: string, callback: Function) => {
      if (this.form.inputType === 'file' && !this.form.dataID.length) {
        return callback(new Error(<string>this.$root.$t('form.upload')))
      }
      callback()
    }
    // qc metric handlers
    const qcMetricHandlers: any = {
      min_genes: (rule: any, value: number, callback: Function) => {
        if ((value < 0 || value > 30000) && value != -1) {
          return callback(new Error(<string>this.$root.$t('form.params.preProcessing.checkMinGenes')))
        }
        callback()
      },
      max_genes: (rule: any, value: number, callback: Function) => {
        if ((value < 0 || value > 90000) && value != -1) {
          return callback(new Error(<string>this.$root.$t('form.params.preProcessing.checkMaxGenes')))
        }
        callback()
      }
    }
    let qcMetricCheckers: any = {}
    let checkProp = (name: string) => {
      const props = ['min_genes', 'max_genes']
      props.forEach((prop: string) => {
        let combineProp = `qcMetricsModel.${name}.${prop}`
        qcMetricCheckers[combineProp] = [
          { validator: qcMetricHandlers[prop], trigger: 'change' }
        ]
      })
    }
    this.form.chooseData.forEach((name: string) => {
      checkProp(name)
    })
    this.form.dataID.forEach((name: string) => {
      checkProp(name)
    })
    return {
      chooseData: [
        { validator: checkInputData, trigger: 'change' }
      ],
      fileId: [
        { validator: checkFile, trigger: 'change' }
      ],
      ...qcMetricCheckers
    }
  }


  @Watch('form.inputType')
  inputTypeChanged() {
    // 数据上传/选择方式改变 清空上传文件列表
    this.form.dataID = []
  }
}
